import * as React from 'react';
import { scrollToTarget, callAll } from '../lib';

type SamePageLinkProps = {
  targetId: string;
} & Omit<JSX.IntrinsicElements['a'], 'href'>;

export const SamePageLink = ({
  targetId,
  onClick,
  ...props
}: SamePageLinkProps) => (
  <a
    href={`#${targetId}`}
    onClick={callAll(ev => {
      ev.preventDefault();
      scrollToTarget(document.getElementById(targetId), {
        offset: window.innerWidth < 680 ? 0 : undefined,
      });
    }, onClick)}
    {...props}
  />
);
